import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
    interface Window {
        Tawk_API?: any;
        Tawk_LoadStart?: Date;
    }
}

const TawkChat: React.FC = () => {
    const location = useLocation();

    useEffect(() => {
        const hideOnPaths = ['/auth'];
        const shouldHide = hideOnPaths.some(path => location.pathname.startsWith(path));

        const controlWidget = (visibility: 'show' | 'hide') => {
            if (window.Tawk_API && typeof window.Tawk_API.hideWidget === 'function') {
                if (visibility === 'hide') {
                    window.Tawk_API.hideWidget();
                } else {
                    window.Tawk_API.showWidget();
                }
            }
        };

        if (shouldHide) {
            controlWidget('hide');
            return;
        }

        // On allowed routes, initialize if not already done
        if (!document.getElementById('tawk-script')) {
            window.Tawk_API = window.Tawk_API || {};
            window.Tawk_LoadStart = new Date();

            const script = document.createElement("script");
            script.id = 'tawk-script';
            script.async = true;
            script.src = import.meta.env.VITE_TAWK_API;
            script.charset = 'UTF-8';
            script.setAttribute('crossorigin', '*');

            const firstScript = document.getElementsByTagName("script")[0];
            if (firstScript && firstScript.parentNode) {
                firstScript.parentNode.insertBefore(script, firstScript);
            }

            window.Tawk_API.onLoad = () => controlWidget('show');
        } else {
            controlWidget('show');
        }

    }, [location.pathname]);

    return null;
};

export default TawkChat;
